import { useGetIdentity, useLogout } from '@refinedev/core';
import type { PropsWithChildren } from 'react';
import { Link, useLocation } from 'react-router';

import { ui } from '../ui';

/**
 * Casca do painel: marca, navegação e saída.
 *
 * As seções seguem o trabalho de verdade do Junior, não a lista de tabelas do banco:
 * **catálogo** (subir e agendar séries), **moderação** (fila de denúncias, revisão em até
 * 24 h conforme `docs/01`) e **suporte**. Configuração e reembolso entram na Etapa 3, junto
 * com as funções que eles acionam.
 */
const SECOES = [
  { para: '/series', rotulo: 'Catálogo' },
  { para: '/moderacao', rotulo: 'Moderação' },
  { para: '/configuracao', rotulo: 'Configuração' },
] as const;

export function Layout({ children }: PropsWithChildren) {
  const { pathname } = useLocation();
  const { mutate: sair } = useLogout();
  const { data: identidade } = useGetIdentity<{ name?: string }>();

  return (
    <div style={ui.pagina}>
      <header style={ui.barra}>
        <h1 style={ui.marca}>
          venove
          <span style={ui.pontoMarca} />
        </h1>

        <nav style={{ display: 'flex', gap: 4 }}>
          {SECOES.map((s) => {
            const ativa = pathname.startsWith(s.para);
            return (
              <Link
                key={s.para}
                to={s.para}
                style={{ ...ui.navLink, ...(ativa ? ui.navLinkAtivo : null) }}
                aria-current={ativa ? 'page' : undefined}
              >
                {s.rotulo}
              </Link>
            );
          })}
        </nav>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
          {identidade?.name && <span style={{ fontSize: 13, ...ui.dim }}>{identidade.name}</span>}
          <button type="button" onClick={() => sair()} style={ui.botaoSecundario}>
            Sair
          </button>
        </div>
      </header>

      <main style={ui.conteudo}>{children}</main>
    </div>
  );
}
